export default __webpack_public_path__ + "MBD-Teilnahmebedingungen_2024-09.pdf";